export default __webpack_public_path__ + "static/media/rm-you-lose.cebbe5ec.svg";